<template>
  <div class="page-2019-lottery-pmd"
       v-if="lottery"
  >
    <img class="banner-img"
         :src="require('@/pages/2019/TourLottery/assets/img/banner.png')"
         alt=""
    >
    <div class="topic-info">
      <span>锻炼孩子的坚毅力、自然探索能力</span>
      <span>格尔木——给孩子一个神奇的暑假之旅</span>
    </div>
    <div class="prize-info">
      <img class="cover"
           :src="require('@/pages/2019/TourLottery/assets/img/prize_cover.png')"
           alt=""
      >
      <div class="info">
        <span class="title">格尔木·少年探索者计划</span>
        <span class="price">价值<span class="num">¥22800</span></span>
      </div>
      <action-btn :is-member="lottery.isMember"
                  :is-login="lottery.isLogin"
                  :status="lottery.status"
                  :has-oauth="lottery.hasOauth"
                  :user-flag="userFlag"
                  v-if="lottery"
      />
      <div class="ticket-entrance"
           @click="handleShowTicketList"
           v-if="ticket.length > 0"
      >
        您的抽奖券
      </div>
      <div class="gift-tip"
           v-else
      >
        *成功参与后更可免费获取一份<br/>
        少年商学院音频课程《美国中小学极简演讲课》
      </div>
    </div>
    <div class="lottery-info">
      <template v-if="lottery && lottery.lotteryTime > 0">
        <div class="date"
             v-if="lottery"
        >
          开奖时间：{{ lottery.lotteryTime|formatTime('yyyy-MM-dd HH:ii') }}
        </div>
        <count-down :start="lottery.currentTime"
                    :end="lottery.lotteryTime"
                    align="center"
                    v-if="lottery"
        />
      </template>
      <template v-else>
        <div class="lottery-result">
          已开奖<br/>
          请前往少年商学院公众号查看开奖结果
        </div>
      </template>
      <img class="lottery-step"
           :src="require('@/pages/2019/TourLottery/assets/img/activity_step.png')"
           alt=""
      >
    </div>
    <div class="gift-info"
         v-if="lottery && lottery.isMember"
    >
      <div class="title">福利音频</div>
      <img src="https://assets.youthmba.com/files/tmp/2019/03-18/14540802228b271411.png" alt="">
      <span class="tip">*温馨提示：收听后记得收藏少年商学院，更多精彩音频课等你发掘</span>
      <a class="gift-detail" href="https://m.youthmba.com/mobile_web/audio/113">立即收听</a>
    </div>
    <span class="get-coupon-rule"
          @click="handleShowGetTicketRulePopup"
    >
      如何获得优惠券
    </span>
    <div class="prize-detail">
      <span class="header">奖品介绍</span>
      <p>
        格尔木（Golmud，蒙古语译音），被国家地理杂志称为，“大西北最神奇的地方”，它地处甘、青、新、藏四省区通衢要地，
        集沙漠、森林、雪山、盐湖、草原于一身，这里的一切都与众不同，让人心潮澎湃。
      </p>
      <!--<swiper :banner="swiperBanner"></swiper>-->
      <video class="video"
             :src="video.url"
             :poster="video.src"
             controls
             controlslist="nodownload"
             v-if="video"
      ></video>
      <p>
        2019年少年商学院夏令营《格尔木·少年探索者计划》，将带领孩子，用八天时间，探索这块大西北最神奇的地方，
        沙漠雪山盐湖集于一地，一生难得奇遇， 12堂跨学科课程大开眼界。
      </p>
      <div class="activity-info">
        <div class="item">
          <span class="name">项目时间</span>
          <span class="desc">2019年8月3-8月10日（8天7晚）</span>
        </div>
        <div class="item">
          <span class="name">集合地点</span>
          <span class="desc">青海西宁；然后航班飞往格尔木</span>
        </div>
        <div class="item">
          <span class="name">学员年龄</span>
          <span class="desc">11-15岁青少年（家长不陪同）</span>
        </div>
      </div>
    </div>
    <span class="activity-rule"
          @click="handleActivityRulePopup"
    >
      活动规则
    </span>
    <div class="qr-code-block">
      <div class="tips-block">
        <div class="tips">
          中奖码将在开奖当日于<br/>
          少年商学院公众号公布
        </div>
      </div>
      <div class="qr-code"
           v-if="qrCode"
      >
        <img :src="qrCode.src" alt="二维码">
      </div>
    </div>

    <center-popup class="ticket-list-popup"
                  :show.sync="showTicketListPopup"
                  title="抽奖券"
    >
      <div class="list"
           v-if="ticket.length > 0"
      >
        <span v-for="(item, index) in ticket"
              :key="index"
        >
          {{ item }}
        </span>
      </div>
    </center-popup>

    <center-popup class="get-ticket-rule-popup"
                  :show.sync="showGetTicketRulePopup"
                  title="如何获得抽奖券"
    >
      <div class="content">
        1. 注册参与抽奖可获1张抽奖券。<br/>
        2. 首次邀请好友助力，立即可获2张抽奖券。<br/>
        3. 每一位好友为你助力可获得1张抽奖券。<br/>
        4. 一个微信号只可助力一次。
      </div>
    </center-popup>

    <center-popup class="activity-rule-popup"
                  :show.sync="showActivityRulePopup"
                  title="活动规则"
    >
      <div class="content">
        · 参与抽奖活动需注册登录少年商学院，即可获得少年商学院福利音频课 给父母的家教宝典-《敢让孩子做自己》<br/>
        · 本次共抽2位用户免费获得 少年商学院2019青海夏令营 格尔木·少年探索者计划名额<br/>
        · 若被发现采用恶意手段获得抽奖券，将取消中奖资格<br/>
        · 中奖码将在开奖当日于少年商学院公众号公布<br/>
        · 中奖用户如因个人原因（年龄，身体状况，时间等）无法参加，视为用户主动放弃奖品，将不作补偿<br/>
        · 活动最终解释权归少年商学院所有
      </div>
    </center-popup>
  </div>
</template>

<script>
  import CountDown from '@/pages/2019/TourLottery/PMD/components/CountDown';
  import { getLotteryJoinDetail, lotteryShare } from '@/services/tour-lottery';
  import shareMixin from '@/mixins/share';
  import ActionBtn from '@/pages/2019/TourLottery/PMD/components/ActionBtn';
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'Year2019LotteryPMD',
    mixins: [shareMixin],
    components: {
      CountDown,
      ActionBtn,
      CenterPopup,
    },
    data() {
      return {
        lottery: null,
        qrCode: null,
        video: null,
        ticket: [],
        showLoginModal: false,
        showTicketListPopup: false,
        showGetTicketRulePopup: false,
        showActivityRulePopup: false,
        userFlag: '',
      };
    },
    methods: {
      async fetchData() {
        const data = await getLotteryJoinDetail();
        this.lottery = data.lottery;
        this.qrCode = data.qrCode;
        this.ticket = data.ticket;
        this.video = data.video;
      },
      async lotteryShare(type) {
        await lotteryShare(type);
      },
      shareSuccessListener() {
        this.$wechat.once('triggerShareTimeline', () => {
          // qq空间 朋友圈
          this.lotteryShare('timeLine');
        });
        this.$wechat.once('triggerShareAppMessage', () => {
          // qq好友 朋友
          this.lotteryShare('appMessage');
        });
        this.$wechat.once('triggerShareWeibo', () => {
          // weibo
          this.lotteryShare('weiBo');
        });
      },
      handleShowTicketList() {
        this.showTicketListPopup = true;
      },
      handleShowGetTicketRulePopup() {
        this.showGetTicketRulePopup = true;
      },
      handleActivityRulePopup() {
        this.showActivityRulePopup = true;
      },
    },
    created() {
      this.fetchData();
      this.shareSuccessListener();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/pages/2019/TourLottery/assets/styles/var.less';

  .page-2019-lottery-pmd {
    padding-bottom: 100px;
    font-size: @font-size-base;
    color: @color-white;
    background: @page-color;
  }
  .banner-img {
    width: 100%;
  }
  .topic-info {
    margin: 50px auto 15px;
    font-size: @font-size-base;
    text-align: center;
    color: @color-white;
    span {
      display: block;
      line-height: 1;
      &:not(:last-child) {
        margin-bottom: @size-small;
      }
    }
  }
  .prize-info {
    margin: 0 auto;
    padding: 0 @size-large;
    box-sizing: border-box;
    width: 750px;
    height: 802px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('~@/pages/2019/TourLottery/assets/img/prize_block.png') no-repeat;
    background-size: 750px 802px;
    color: @color-white;
    .cover {
      margin: @size-large auto @size-base;
      width: 630px;
    }
  }
  .info {
    margin-bottom: 46px;
    padding: 0 @size-large;
    width: 100%;
    box-sizing: border-box;
    font-size: @font-size-base;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .price {
      font-size: @font-size-medium;
      color: @color-highlight;
      .num {
        font-weight: @font-weight-bold;
      }
    }
  }
  .ticket-entrance {
    margin-top: @size-small;
  }
  .gift-tip {
    margin-top: @size-medium;
    font-size: @font-size-extra-small;
    text-align: center;
    line-height: 1.8;
  }
  .lottery-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .date {
      margin-bottom: 56px;
      font-size: @font-size-medium;
    }
    .lottery-step {
      margin-top: 60px;
      width: 670px;
    }
    .lottery-result {
      text-align: center;
      font-weight: @font-weight-bold;
    }
  }
  .get-coupon-rule {
    display: block;
    width: fit-content;
    margin: @size-medium auto;
    color: @color-highlight;
    font-size: @font-size-base;
    position: relative;
    &:after {
      position: absolute;
      right: -36px;
      top: 6px;
      content: '?';
      width: @size-base;
      height: @size-base;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-highlight;
      color: #343b41;
      border-radius: 50%;
    }
  }
  .gift-info {
    margin: @size-large auto;
    .title {
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      color: @color-highlight;
      text-align: center;
      margin-bottom: @size-base;
    }
    img {
      display: block;
      width: 690px;
      margin: 0 auto;
    }
    .gift-detail {
      display: block;
      height: 60px;
      line-height: 60px;
      margin: @size-small auto;
      padding: 0 @size-small;
      box-sizing: border-box;
      width: fit-content;
      background: @color-highlight;
      color: @color-white;
      border: @border-width-base @border-style-base @color-highlight;
      border-radius: @border-radius-normal;
    }
    .tip {
      margin-left: @size-base;
      font-size: @font-size-extra-small;
      color: fade(@color-white, 40%);
    }
  }
  .prize-detail {
    padding: 60px @size-large;
    width: 100%;
    height: 1540px;
    background: url('~@/pages/2019/TourLottery/assets/img/gift_block.png');
    background-size: contain;
    box-sizing: border-box;
    .header {
      margin: 0 auto 68px;
      display: block;
      width: fit-content;
      font-size: 38px;
      font-weight: @font-weight-bold;
      position: relative;
      text-align: center;
      &:after {
        position: absolute;
        left: 28px;
        bottom: -28px;
        content: '';
        width: 96px;
        height: 8px;
        border-radius: @border-radius-base;
        background: @color-highlight;
      }
    }
    p {
      width: 630px;
      word-break: break-all;
      margin: 0;
      line-height: 1.8;
    }
  }
  .video {
    margin: @size-base auto;
    width: 630px;
    height: 346px;
  }
  .activity-info {
    margin: 90px auto 0;
    .item {
      display: flex;
      align-items: center;
      position: relative;
      &:after {
        width: 550px;
        height: 1px;
        position: absolute;
        left: 28px;
        bottom: -12px;
        content: '';
        border-bottom: @border-width-base dashed @color-white;
      }
      &:not(:last-child) {
        margin-bottom: 25px;
      }
    }
    .name {
      margin-right: @size-base;
      display: block;
      width: 144px;
      height: 48px;
      line-height: 48px;
      font-size: 26px;
      font-weight: @font-weight-bold;
      text-align: center;
      background: @color-highlight;
      border-radius: 24px;
    }
  }
  .activity-rule {
    display: block;
    width: fit-content;
    margin: 0 auto @size-medium;
    color: @color-highlight;
    font-size: @font-size-base;
    position: relative;
    &:after {
      position: absolute;
      right: -36px;
      top: 6px;
      content: '!';
      width: @size-base;
      height: @size-base;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-highlight;
      color: #343b41;
      border-radius: 50%;
    }
  }
  .qr-code-block {
    margin: 0 auto;
    width: 660px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .tips-block {
      width: 430px;
      height: 226px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border: 1px solid #24a5c5;
      border-radius: 20px 0 0 20px;
      border-right: none;
    }
    .tips {
      width: 396px;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      background: #249fb7;
      border-radius: 20px 0 0 20px;
    }
    .qr-code {
      width: 230px;
      height: 226px;
      padding: 14px;
      box-sizing: border-box;
      background: linear-gradient(to bottom, #18697d, #004895);
      img {
        display: block;
        width: 198px;
        height: 198px;
      }
    }
  }
  .ticket-list-popup {
    .list {
      padding: @size-base;
      color: @color-text-base;
      text-align: center;
    }
  }
  .get-ticket-rule-popup,
  .activity-rule-popup {
    .content {
      padding: @size-base;
      font-size: @font-size-base;
      color: @color-text-base;
      line-height: 1.4;
    }
  }
</style>
